module.exports = __webpack_public_path__ + "ccbdcea2326ddf9c680d95b5065003e9.svg";